import React from 'react';
import { View, Text, StyleSheet, Platform, TouchableOpacity, Image } from 'react-native';
import { COLORS } from '../theme/themeTokens';

export type SimpleHeaderBackground = 'primaryNavy' | 'white';

interface SimpleHeaderProps {
    title: string;
    onBack: () => void;
    /** Background colour of the header. Defaults to 'primaryNavy'. */
    backgroundVariant?: SimpleHeaderBackground;
}

const SimpleHeader: React.FC<SimpleHeaderProps> = ({
    title,
    onBack,
    backgroundVariant = 'primaryNavy',
}) => {
    // Aligned with DashboardHeader so internal screens share the same
    // status-bar gutter (was 34 iOS / 54 Android — roughly twice as tall).
    const statusBarHeight = Platform.OS === 'android' ? 28 : 20;
    const isLight = backgroundVariant === 'white';

    return (
        <View
            style={[
                styles.headerBackground,
                { minHeight: statusBarHeight + 40 },
                isLight ? styles.headerBackgroundLight : styles.headerBackgroundDark,
            ]}>
            <TouchableOpacity
                style={styles.headerRow}
                activeOpacity={0.7}
                onPress={() => {
                    onBack();
                }}
            >
                <Image
                    source={
                        isLight
                            ? require('../assets/arrow_left_20.png')
                            : require('../assets/arrow_left_20_white.png')
                    }
                    style={styles.headerBackIcon}
                />
                <Text
                    style={[
                        styles.headerTitle,
                        isLight ? styles.headerTitleLight : styles.headerTitleDark,
                    ]}>
                    {title}
                </Text>
                <View style={styles.headerSpacer} />
            </TouchableOpacity>
        </View>
    );
};

const styles = StyleSheet.create({
    headerBackground: {
        justifyContent: 'center',
    },
    headerBackgroundDark: {
        backgroundColor: COLORS.primaryNavy,
    },
    headerBackgroundLight: {
        backgroundColor: COLORS.white,
    },
    headerRow: {
        flexDirection: 'row',
        alignItems: 'center',
        paddingHorizontal: 16,
        minHeight: 48,
        paddingVertical: 8,
        paddingBottom: Platform.OS === 'android' ? 8 : 20,
        // marginTop was 30 — dropped so the title sits closer to the
        // status bar, matching the dashboard's compact header.
    },
    headerBackButton: {
        marginBottom: 0,
    },
    headerBackIcon: {
        width: 18,
        height: 18,
        marginRight: 4,
    },
    headerTitle: {
        flex: 1,
        textAlign: 'center',
        fontFamily: 'Inter',
        fontSize: 20,
        lineHeight: 32,
        fontWeight: '500',
    },
    headerTitleLight: {
        color: COLORS.primaryNavy,
    },
    headerTitleDark: {
        color: COLORS.white,
    },
    headerSpacer: {
        width: 20,
    },
});

export default SimpleHeader;
